import { Controller } from '@hotwired/stimulus'

// Add/remove rows in an indexed-field list (analogies, citations). The
// template's field names contain __INDEX__, replaced with a fresh index on
// add. Removal just drops the row from the DOM — absent fields are dropped
// server-side on save.
export default class extends Controller {
  static targets = ['list', 'template']

  connect() {
    this.nextIndex = this.listTarget.children.length
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll('__INDEX__', this.nextIndex++)
    this.listTarget.insertAdjacentHTML('beforeend', html)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest('[data-rows-row]')?.remove()
  }
}
